import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import type { ContextFamily, ContextTone } from '@quipex/shared/utils';
import { Skeleton } from './skeleton';

@Component({
    selector: 'qpx-skeleton-avatar',
    imports: [Skeleton],
    template: `
        <qpx-skeleton
            [context]="context()"
            [tone]="tone()"
            [height]="size()"
            [width]="size()"
            aspectRatio="1"
            borderRadius="var(--qpx-radius-sm)"
            [ariaLabel]="ariaLabel()"
        />
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'block shrink-0',
    },
})
export class SkeletonAvatar {
    //#region Inputs
    public readonly context = input<ContextFamily>();
    public readonly tone = input<ContextTone>();
    public readonly size = input('2.5rem');
    public readonly ariaLabel = input('');
    //#endregion
}
